import React from "react";
import { FaMagic } from "react-icons/fa";
import "./PageHeader.scss";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import UpgradeModal from "../UpgradeModal";

interface PageHeaderProps {
  title: string;
  buttonText?: string;
  buttonIcon?: React.ReactNode;
  onButtonClick?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  buttonText = "Upgrade",
  buttonIcon = <FaMagic />,
  onButtonClick,
}) => {
  const isAdmin = useSelector((state: RootState) => state.auth.user?.is_admin === true);
  return (
    <div className="page-header-container">
      <span className="page-header-title">{title}</span>
      {buttonText && !isAdmin && (
        <UpgradeModal
          onTriggerClick={onButtonClick}
          trigger={
            <button className="page-header-upgrade-btn">
              {buttonIcon} {buttonText}
            </button>
          }
        />
      )}
    </div>
  );
};

export default PageHeader;
